import { render } from "./UpdateDialog.vue?vue&type=template&id=5f1021b0&scoped=true&ts=true"
import script from "./UpdateDialog.vue?vue&type=script&lang=ts"
export * from "./UpdateDialog.vue?vue&type=script&lang=ts"

import "./UpdateDialog.vue?vue&type=style&index=0&id=5f1021b0&scoped=true&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f1021b0"]])

export default __exports__